<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت لایت باکس</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;" class="ax"><!--Row #2-->
                  <v-layout row wrap> 
                       <v-flex xs12 sm12 md6 lg6 xl6 style="margin:auto;padding:20px" v-for="(item,i) in Boxs" :key="i">
                           <v-card>
                               <v-card-title>
                                   <div class="text-xs-center">
                                       لایت باکس صفحه اصلی
                                   </div>
                               </v-card-title>
                               <input type="file" @change="loadFileDataUrl($event,i)" style="display:none" ref="bxImg" accept="image/*" />
                                <v-img style="max-height:500px !important;overflow:hidden" width="100%" height="100%" :src="item.image" contain>
                                    <v-overlay absolute>
                                        <v-btn @click="$refs.bxImg[i].click()" v-if="!inUploading" color="blue-grey darken-4" ><v-icon  color="#fff">fas fa-camera</v-icon></v-btn>&nbsp;
                                        <v-btn v-if="item.displayUploadBtn && !inUploading" color="blue-grey darken-4" @click="uploadGImage($refs.bxImg[i],i)"><v-icon color="#fff">fas fa-upload</v-icon></v-btn>
                                    </v-overlay>
                                </v-img>
                               <v-card-text>
                                   <v-layout row wrap>
                                       <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                                           <v-text-field v-model="item.title" hint="عنوان" placeholder="عنوان" outlined dense></v-text-field>
                                       </v-flex>
                                       <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                                           <v-text-field v-model="item.link" hint="لینک" placeholder="لینک" outlined dense></v-text-field>
                                       </v-flex>
                                       <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                                           <v-row>
                                                <v-col cols="8">وضعیت :</v-col>
                                                <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                                    <v-switch v-model="item.status" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                                </v-col>
                                           </v-row>
                                       </v-flex>
                                       <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                                           <v-btn @click="registerCategory" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                       </v-flex>
                                   </v-layout>
                               </v-card-text>
                           </v-card>
                       </v-flex>
                  </v-layout>
            </v-flex>
        </v-layout>
       
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
    </div>
</template>
<style>
.ax .v-responsive__content
{
    min-height: 300px;
}
</style>
<style scoped>

.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import { mapState, mapMutations, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueEditor } from "vue2-editor";
export default {
    name:"LightBox",
   components: {
            Loading,
            VueEditor
        },
    data:()=> ({
        CurrentPageName:"LightBox",
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        seo:{},
        ALLOEWDIMGSIZE:{},
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        EditorContent:"",
        bx1Img:"",
        bx2Img:"",
        bx3Img:"",
        bx4Img:"",
        bx5Img:"",
        bx6Img:"",
        displayUploadBtnBX1:false,
        displayUploadBtnBX2:false,
        displayUploadBtnBX3:false,
        displayUploadBtnBX4:false,
        displayUploadBtnBX5:false,
        displayUploadBtnBX6:false,
        selectedImageFile:"",
        inUploading:false,
        Boxs:[
            {image:"noimage.png",title:"",link:"",bxImg:"",status:false,displayUploadBtn:false},
        ]
    }),
    async created()
    {
        let vm = this;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
       
    },
    methods:{
    setImageUrls()
    {
        let vm = this;
        let bxs = vm.Boxs;
       let url = ApiUrl.SectionImg;
       vm.Boxs = [];
       bxs.forEach((item)=>{
           item.image = url+item.image;
           vm.Boxs.push(item);
       });
    },
     async uploadGImage(r,el)
      {
            let vm = this;
            var data = new FormData();
            data.append("File",r.files[0]);
            vm.inUploading = true;
            await axios.post(ApiUrl.uploadIndexSections+'/SECTION',data)
                .then(function (res) {
                    console.log(res);
                    vm.inUploading = false;
                    if(res.data.status)
                    {
                        vm.Boxs[el].image = ApiUrl.SectionImg+res.data.data;
                        vm.Boxs[el].displayUploadBtn = false;
                        
                        MSGHNDL.OK("فایل  با موفقیت آپلود شد");
                 
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
         
      },

        loadFileDataUrl(evt,el)
      {
          let vm = this;
          var files = evt.target.files[0];
          vm.selectedImageFile = files;
          var reader = new FileReader();
          reader.onload = (function(theFile) {
        return function(e) {
            vm.Boxs[el].image = e.target.result;
            vm.Boxs[el].displayUploadBtn = true;
           
        };
         })(files);

      // Read in the image file as a data URL.
        reader.readAsDataURL(files);
      },
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.$store.getters.getSeoForm;
           
        },
        async loadCategories()
        {
            let vm = this;
            vm.isLoadingCats = true;
            let Model ={};
            Model.PageName = "LightBox";
            await axios.post(ApiUrl.GetPageContent,Model).then(async (res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.Boxs = JSON.parse(data.data.pageOtherSetting);
                    vm.setImageUrls();
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async registerCategory()
        {
            let vm = this;
            let Model = {};
            Model.PageName = "LightBox";
            Model.PageContent = "";
            Model.PageId = "";
            Model.PageSeo = "";
            let bxs = [];
            vm.Boxs.forEach((item)=>{
                let arr = item.image.split('/');
                item.image = arr[arr.length - 1];
                bxs.push(item);
            });
            Model.PageOtherSetting = JSON.stringify(bxs);
            await axios.post(ApiUrl.AddPageContent,Model).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.loadCategories();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        },
        SeoChanged(data)
        {
            this.seo = data;
        }
    }
}
</script>